import { render, staticRenderFns } from "./SpecialDealsCategory.vue?vue&type=template&id=58afab64"
import script from "./SpecialDealsCategory.vue?vue&type=script&lang=js"
export * from "./SpecialDealsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports